import React from 'react';
import PageHero from '../components/PageHero';
import Session from '../components/Session';
import Funding from '../components/Funding';
import FAQ from '../components/FAQ';

const AdmissionFees = () => {
    return (
        <>
            <PageHero title="Enroll with Ease, Grow with Confidence" />
            <Session />
            <Funding />
            <FAQ />
        </>
    );
};

export default AdmissionFees;
